<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
          }}</span>
        <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple" type="danger"
            v-preventReClick @click="handleDelete">删除</el-button>

          <el-button v-if="tableAcl.indexOf('Export') != -1" type="primary" class="btn primary" @click="exportData"
            v-loading="exportButtonLoading" :disabled="exportButtonLoading">导出</el-button>
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange"
            @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <el-button class="btn primary" type="primary" style="margin-right: 10px"
          @click="showTransfer">自定义设置</el-button>
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>

      <div v-if="tableHaeder.length>0">
        <CustomTable  ref="customTable" :tableData="tableData" @handleSelectionChange="handleSelectionChange" :tableHaeder="tableHaeder" :loading="loading"
        @resetMethod="reset" :tableHeight="tableHeight" @onApproveStatusSuccess="getData" :tableCode="route.name"> 
        <template slot="before">
          <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
          </el-table-column>
        </template>
          <template slot="after">
            <el-table-column fixed="right" prop="operation" label="操作" width="180">
              <template slot-scope="scope">
                <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button>
                <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
                  v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
                <el-button v-else-if="
                  scope.row.status != 1 &&
                  scope.row.status != 2 &&
                  tableAcl.indexOf('Edit') != -1
                " type="text" v-preventReClick @click="handleUpdate(scope.row)"
                  class="margin-left20 color-blue">编辑</el-button>
                <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
                  @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
                <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
                <el-button v-if="scope.row.status == 2 && scope.row.sendState == 0" type="text"
                  class="margin-left20 color-blue" @click="sendToMaster(scope.row)">推送</el-button>
                <el-button v-if="
                  tableAcl.indexOf('FinishOrder') != -1 &&
                  scope.row.status == 2 &&
                  scope.row.sendState == 1 &&
                  [7, 8, 9].indexOf(scope.row.state) == -1
                " type="text" class="margin-left20 color-blue" @click="finishApply(scope.row)">关闭计划</el-button>
              </template>
            </el-table-column>
          </template>
        </CustomTable>
      </div>
      <div v-else>
        <el-table ref="multipleTable" border row-key="id" v-loading="loading" :data="tableData" :max-height="tableHeight"
        style="width: 100%" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column width="170" prop="no" label="计划单号">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="170" prop="pressingStateName" label="紧急标识"></el-table-column>
        <el-table-column width="120" prop="createdUserName" label="发起人"></el-table-column>
        <el-table-column width="120" prop="ownerDeptName" label="所属科室"></el-table-column>
        <el-table-column width="160" prop="createdTime" label="创建时间">
          <template slot-scope="scope">{{
            parseTime(new Date(scope.row.createdTime))
            }}</template>
        </el-table-column>
        <el-table-column width="110" prop="stateName" label="状态"></el-table-column>
        <el-table-column width="160" prop="deliveryTime" label="要求送达日期">
          <template slot-scope="scope">{{
            scope.row.deliveryTime?
            parseTime(new Date(scope.row.deliveryTime), "{y}-{m}-{d}"):
            '-'
            }}</template>
        </el-table-column>
        <el-table-column width="120" prop="totalNumber" label="计划总数量"></el-table-column>
        <el-table-column width="120" prop="totalAmount" label="计划总金额"></el-table-column>
        <el-table-column  label="审批人" width="100" align="center"
          prop="approverNames">
          <template slot-scope="scope">
            {{ scope.row.approverNames?scope.row.approverNames:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="statusName" label="流程状态" width="80">
          <template slot-scope="scope">
            <approve-status :row="scope.row" :isWorkflowTable="isWorkflowTable" :options="ApproveStatusOptions"
              @success="getData" :tableCode="route.name"></approve-status>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.remark?scope.row.remark:'-' }}
          </template>
        </el-table-column>
        <el-table-column width="170" prop="sourceApplyNo" label="来源备货申请单号">
          <template slot-scope="scope">
            {{ scope.row.sourceApplyNo?scope.row.sourceApplyNo:'-' }}
          </template>
        </el-table-column>
        <el-table-column width="160" prop="supplierName" label="供应商" show-overflow-tooltip></el-table-column>
        <el-table-column width="90" prop="isTempPurchase" label="临采标识">
          <template slot-scope="scope">
            <span v-if="scope.row.isTempPurchase !== null && scope.row.isTempPurchase !== undefined">
              {{ scope.row.isTempPurchase === 1 ? '是' : '否' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="oneLevelWarehouseInfo" label="收货信息" min-width="160"
          show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" prop="operation" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="scope.row.status == 1 && isShowApproveButton(scope.row.approverIds)" type="text"
              v-preventReClick @click="handleApprove(scope.row)" class="margin-left20 color-blue">审核</el-button>
            <el-button v-else-if="
              scope.row.status != 1 &&
              scope.row.status != 2 &&
              tableAcl.indexOf('Edit') != -1
            " type="text" v-preventReClick @click="handleUpdate(scope.row)"
              class="margin-left20 color-blue">编辑</el-button>
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            <el-button v-if="tableAcl.indexOf('Remove') != -1 && scope.row.status != 2" type="text" v-preventReClick
              @click="handleDelete(scope.row)" class="margin-left20 color-blue">删除</el-button>
            <!-- <span v-else class="margin-left20 color-blue">&nbsp;&nbsp;-&nbsp;&nbsp;</span> -->
            <el-button v-if="scope.row.status == 2 && scope.row.sendState == 0" type="text"
              class="margin-left20 color-blue" @click="sendToMaster(scope.row)">推送</el-button>
            <el-button v-if="
              tableAcl.indexOf('FinishOrder') != -1 &&
              scope.row.status == 2 &&
              scope.row.sendState == 1 &&
              [7, 8, 9].indexOf(scope.row.state) == -1
            " type="text" class="margin-left20 color-blue" @click="finishApply(scope.row)">关闭计划</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
   
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>

    <el-dialog :title="'是否关闭当前备货计划【' + finishForm.no + '】'" :visible.sync="showFinishApplyDialog" width="640px">
      <el-form ref="finishForm" :model="finishForm" label-width="80px" :rules="finishRules">
        <el-row>
          <el-form-item label="原因" prop="remark">
            <el-input v-model="finishForm.remark"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="">
        <el-button class="btn" size="small" v-preventReClick @click="showFinishApplyDialog = false">取 消</el-button>
        <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="finishSubmit">确
          定</el-button>
      </div>
    </el-dialog>
    <Transfer ref="Transfer" @getTabelList="getTabelList" :transfer-props="transferProps" />
  </div>
</template>

<script>
import {
  GetStockUpPlans,
  RemoveStockUpPlan,
  ExportStockUpPlan,
  SendStockUpPlanToMaster,
  FinishStockUpPlan,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import { OrderStateOptions, ApproveStatusOptions, WhetherOptions } from "@/enum";
import SelectFilter from "@/components/table-select-filter";
import BaseListMixin from "@/mixin/baseList-mixin.js";

export default {
  mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],
  components: {
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetStockUpPlans,
      RemoveAction: RemoveStockUpPlan,
      exportAction: ExportStockUpPlan,
      // PrintAction: GetAcceptInStockPrintData,
      editPath: "stock-up-plan-edit",
      WhetherOptions: WhetherOptions,
      OrderStateOptions: OrderStateOptions,
      ApproveStatusOptions: ApproveStatusOptions,
      filterOptions: [
        {
          name: "所属科室",
          type: "select",
          code: "deptId",
          filterMethod: this.getDepts,
          data: [],
        },
        {
          name: "计划单号",
          type: "input",
          code: "keyWord",
        },
        {
          name: "供货商产品",
          type: "select",
          code: "supplierProductId",
          filterMethod: this.getSupplierProductsNoDebounce,
          data: [],
        },
        {
          name: "供应商产品编码",
          type: "input",
          code: "supplierProductNo",
        },
        {
          name: "产品名称",
          type: "input",
          code: "productName",
        },
        {
          name: "规格型号",
          type: "input",
          code: "specName",
        },
        {
          name: "供应商",
          type: "select",
          code: "supplierId",
          filterMethod: this.getSuppliers,
          data: [],
        },
        {
          name: "生产厂家",
          type: "select",
          code: "manufacturerId",
          filterMethod: this.getManufacturers,
          data: [],
        },
        {
          name: "订单状态",
          type: "select",
          code: "states",
          data: OrderStateOptions,
          multiple: true,
        },
        {
          name: "审批人",
          type: "select",
          code: "approveId",
          filterMethod: this.getApproves,
          data: [],
        },
        {
          name: "流程状态",
          type: "select",
          code: "statuses",
          multiple: true,
          data: ApproveStatusOptions,
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
        {
          name: "主条码",
          type: "input",
          code: "mainNo",
        },
        {
          name: "来源备货申请单号",
          type: "input",
          code: "sourceApplyNo",
        },
        {
          name: "临采标识",
          type: "select",
          code: "isTempPurchase",
          data: WhetherOptions,
        },
      ],
      showFinishApplyDialog: false,
      finishForm: {},
      finishRules: {
        remark: [{ required: true, message: "请输入原因", trigger: "blur" }],
      },
    };
  },
  methods: {
    sendToMaster (row) {
      SendStockUpPlanToMaster({ id: row.id }).then((res) => {
        if (!res.successful) {
          return;
        }
        this.getData();
        this.$my_message("推送成功", "success");
      });
    },
    finishApply (row) {
      this.showFinishApplyDialog = true;
      this.finishForm = {
        id: row.id,
        no: row.no,
        remark: "",
      };
    },
    finishSubmit () {
      this.$refs.finishForm.validate((valid) => {
        if (valid) {
          FinishStockUpPlan(this.finishForm).then((res) => {
            if (!res.successful) {
              return;
            }
            this.showFinishApplyDialog = false;
            this.getData();
            this.$my_message("关闭成功", "success");
          });
        }
      });
    },
  },
  mounted () { },
};
</script>

<style lang="scss" scoped></style>
